/* =========================================================================
   kitsters-instafeed-loader.js
   ONE loader for every Mintt Instafeed band on the site (homepage Makers +
   the PDP "Tagged @kitsters" band). It swaps our skeleton for the real feed
   the moment the app injects its first <img>, and — where the band opts in —
   hides the whole band if the app has nothing to show.

   It never reads, styles or touches Mintt's internal DOM. The ONLY signal it
   uses is "does an <img> exist inside our own wrapper yet".

   Lifted out of kitsters-home.js (initMakersFeedLoader) on 2026-08-19 so the
   two bands share one definition rather than drifting apart — CLAUDE.md §10.75.

   Hooks (both on the wrapper div):
     data-instafeed-feed          — required; the wrapper carrying .is-loading
     data-instafeed-hide-if-empty — optional; hide the band when the feed is empty
   ========================================================================= */
(function () {
  'use strict';

  /* The app is given this long to render before we call the feed empty. The
     homepage has always used 8s as its "stop showing the skeleton" timeout;
     the same number decides "there is nothing here" for a band that opts in. */
  var GIVE_UP_MS = 8000;

  function hasImage(feed) {
    return !!feed.querySelector('img');
  }

  function init(feed) {
    var section = feed.closest('[data-instafeed-section]');
    var hideIfEmpty = feed.hasAttribute('data-instafeed-hide-if-empty') && section;

    function markLoaded() {
      feed.classList.remove('is-loading');
      if (section) section.classList.remove('is-empty');
    }

    if (hasImage(feed)) { markLoaded(); return; }

    /* Keep observing AFTER the timeout: a slow app that renders at 12s should
       bring a hidden band back rather than stay hidden for the session. */
    var mo = new MutationObserver(function () {
      if (hasImage(feed)) {
        markLoaded();
        mo.disconnect();
      }
    });
    mo.observe(feed, { childList: true, subtree: true });

    window.setTimeout(function () {
      /* Never leave the skeleton showing forever if the app is slow or down. */
      feed.classList.remove('is-loading');

      /* An empty band is worse than no band: on a product with no tagged posts
         the app renders nothing, and without this the page would carry a
         heading, a sub and a Follow button over a blank gap. */
      if (hideIfEmpty && !hasImage(feed)) section.classList.add('is-empty');
    }, GIVE_UP_MS);
  }

  function boot() {
    var feeds = document.querySelectorAll('[data-instafeed-feed]');
    for (var i = 0; i < feeds.length; i++) init(feeds[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
